import React, { useState, useRef } from "react";
import { Tooltip } from "antd";
import Lottie from "lottie-react";
import animationData from "../../assets/animations/ester-lottie.json";
import EsterChatModal from "../EsterChatModal";
import "./style.css";

const ChatbotButton = () => {
  const [isHovered, setIsHovered] = useState(false);
  const [isChatOpen, setIsChatOpen] = useState(false);
  const lottieRef = useRef();

  const handleClick = () => {
    setIsChatOpen(true);
  };

  return (
    <>
      <Tooltip 
        title="Ester" 
        placement="top" 
        open={isHovered}
        mouseEnterDelay={0}
        mouseLeaveDelay={0}
        overlayClassName="ester-tooltip"
        align={{
          offset: [0, -18]
        }}
      >
        <div
          className="chatbot-button-container"
          onClick={handleClick}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          role="button"
          tabIndex={0}
          aria-label="Open Ester Chatbot"
          onKeyPress={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              handleClick();
            }
          }}
        >
          <div className={`chatbot-animation ${isHovered ? "hovered" : ""}`}>
            <Lottie
              lottieRef={lottieRef}
              animationData={animationData}
              loop={true}
              autoplay={true}
              style={{ width: "100%", height: "100%" }}
            />
          </div>
        </div>
      </Tooltip>
      
      <EsterChatModal 
        isOpen={isChatOpen}
        onClose={() => setIsChatOpen(false)}
      />
    </>
  );
};

export default ChatbotButton;

